import { Button } from '@givebutter/primitives/button';
import { faChevronDown, faGift, faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as DropdownMenu from 'components/dropdown-menu';
import * as AuctionPartnersDialog from 'components/pages/campaign-settings/campaign-auction/sponsors/AuctionPartnersDialog';
import { useCampaignItemRoutes } from 'components/pages/campaign-settings/campaign-auction/useCampaignItemRoutes';

const CreateItemDropdown = () => {
    const itemRoutes = useCampaignItemRoutes();

    return (
        <DropdownMenu.Root>
            <DropdownMenu.Trigger asChild>
                <Button variant="solid" className="group">
                    <span>Add item</span>
                    <FontAwesomeIcon
                        icon={faChevronDown}
                        className="group-radix-state-open:rotate-180"
                    />
                </Button>
            </DropdownMenu.Trigger>
            <DropdownMenu.Content align={'end'}>
                <DropdownMenu.LinkItem to={itemRoutes.create()}>
                    <FontAwesomeIcon icon={faPlus} className="mr-2" />
                    Create new item
                </DropdownMenu.LinkItem>
                <DropdownMenu.Item className={`!p-0`} onSelect={e => e.preventDefault()}>
                    <AuctionPartnersDialog.Root>
                        <AuctionPartnersDialog.Trigger>
                            <p className={`flex items-center gap-2 px-1 py-2 text-sm`}>
                                <FontAwesomeIcon icon={faGift} />
                                Auction packages
                            </p>
                        </AuctionPartnersDialog.Trigger>
                    </AuctionPartnersDialog.Root>
                </DropdownMenu.Item>
            </DropdownMenu.Content>
        </DropdownMenu.Root>
    );
};

export { CreateItemDropdown };
